// extracted by mini-css-extract-plugin
module.exports = {"header":"dropdown-box_header__FkF2p","box":"dropdown-box_box__1OlfD","content":"dropdown-box_content__3y45I"};